<div class="flex flex-col gap-6">
  <div class="isolate relative overflow-hidden rounded-2xl">
    <div class="pointer-events-none absolute inset-x-0 top-0 h-full min-h-[22rem] overflow-hidden md:min-h-[28rem]">
      @if (coverImageSrc) {
        <img
          [src]="coverImageSrc"
          [alt]="courseNameDisplay"
          class="h-full w-full object-cover object-center opacity-95 mask-fade-bottom"
        />
      } @else {
        <div class="h-full w-full bg-lGray950"></div>
      }

      <div class="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-lBlack/35 to-transparent"></div>
    </div>

    <section class="relative z-10 flex min-h-[22rem] w-full items-end px-6 pb-6 md:min-h-[28rem] md:pb-8">
      <div class="flex w-full flex-col gap-4">
        <h1 class="text-3xl font-semibold tracking-tight text-lWhite md:text-4xl">
          {{ courseNameDisplay }}
        </h1>
        <hr class="w-full border-0 border-t border-lWhite/15" />
      </div>
    </section>
  </div>

  <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
    <div class="flex min-w-0 flex-col gap-5">
      <div class="flex min-w-0 flex-col gap-2">
        <span class="text-sm font-medium text-lGray500">Curso</span>
        <div class="relative">
          <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">school</l-icon>
          <p class="min-h-12 rounded-xl bg-lGray950 px-4 py-3 pl-11 text-base text-lGray500">
            {{ courseNameDisplay }}
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div class="flex min-w-0 flex-col gap-2">
          <span class="text-sm font-medium text-lGray500">Categoria</span>
          <div class="relative">
            <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">grid_view</l-icon>
            <p class="min-h-12 rounded-xl bg-lGray950 px-4 py-3 pl-11 text-base text-lGray500">
              {{ categoryDisplay }}
            </p>
          </div>
        </div>

        <div class="flex min-w-0 flex-col gap-2">
          <span class="text-sm font-medium text-lGray500">Tags de pesquisa</span>
          <div class="relative">
            <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">search</l-icon>
            <p class="min-h-12 rounded-xl bg-lGray950 px-4 py-3 pl-11 text-base text-lGray500">
              {{ tagsDisplay }}
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div class="flex min-w-0 flex-col gap-2">
          <span class="text-sm font-medium text-lGray500">Tempo de duração</span>
          <div class="relative">
            <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">schedule</l-icon>
            <p class="min-h-12 rounded-xl bg-lGray950 px-4 py-3 pl-11 text-base text-lGray500">
              {{ durationDisplay }}
            </p>
          </div>
        </div>

        <div class="flex min-w-0 flex-col gap-2">
          <span class="text-sm font-medium text-lGray500">Módulos</span>
          <div class="relative">
            <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600">deployed_code</l-icon>
            <p class="min-h-12 rounded-xl bg-lGray950 px-4 py-3 pl-11 text-base text-lGray500">
              {{ moduleCount }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex min-w-0 flex-col gap-5">
      <div class="flex min-w-0 flex-col gap-2">
        <span class="text-sm font-medium text-lGray500">Descrição curta</span>
        <div class="relative">
          <l-icon class="pointer-events-none absolute left-4 top-4 text-xl text-lGray600">format_align_left</l-icon>
          <p class="min-h-12 rounded-xl bg-lGray950 px-4 py-3 pl-11 text-base text-lGray500">
            {{ shortDescriptionDisplay }}
          </p>
        </div>
      </div>

      <div class="flex min-w-0 flex-col gap-2">
        <span class="text-sm font-medium text-lGray500">Descrição detalhada</span>
        <p class="min-h-32 rounded-xl bg-lGray950 px-4 py-3 text-base leading-relaxed text-lGray500 whitespace-pre-wrap">
          {{ detailedDescriptionDisplay }}
        </p>
      </div>
    </div>
  </div>
</div>
